<template>
  <div>
    <drawer :app="app" />

    <v-container class="mt-1">           
        <v-card  raised >
        <v-card-title>
          <div>{{ $t("labels.RequiredDocuments") }}</div>
        </v-card-title>          
         <v-card-text>
            <v-tabs v-model="tabModel" centered slider-color="primary" background-color="gray">
            <v-tab href="#tab-1"> <h3>{{ $t("labels.UploadDocuments") }}</h3></v-tab>
            <!-- <v-tab href="#tab-2">
              <h3>
               {{ $t("labels.Notes") }}
              </h3></v-tab
            > -->
          </v-tabs>
            <v-tabs-items v-model="tabModel">
            <v-tab-item value="tab-1">               
              <p  v-html="app.RequestDocument.Desc" />

              <p v-html="$t('messages.UploadDescV2')" />

              <v-card  class="mb-3" outlined v-for="(d, idx) in app.RequestDocument.Items" v-bind:key="d.DFRequestDocItemID">
                <v-card-text style="color:black;">
                  <v-row dense>
                    <v-col cols="12" sm="8">
                      <div class="headline" style="font-size: 19px !important;">{{ d.strDFDocumentType }}</div>
                      <div v-if="d.DFRequestDocItemStatusDD == 3"></div>
                      <div v-text="d.Desc" />
                      <v-list-item-subtitle v-if="1==2">{{ d.Desc }}</v-list-item-subtitle>
                      <div class="mt-3">
                        <v-row dense v-for="f in d.Uploads" v-bind:key="f.DFRequestDocItemUploadID">
                          <v-col cols="8">
                            <div class="text-truncate" v-text="f.FileName" />
                          </v-col>
                          <v-col cols="3" v-text="f.strUploadDate" />
                          <v-col cols="1">
                            <a
                              v-if="d.DFRequestDocItemStatusDD == 1 || d.DFRequestDocItemStatusDD == 3 || (d.DFRequestDocItemStatusDD == 4 && f.RemoveFlag == true)"
                              link
                              @click="removeUpload(f.DFRequestDocItemUploadID, d.DFRequestDocItemID)"
                              style="color:red;"
                            >
                              <i class="fas fa-trash-alt"></i>
                            </a>
                          </v-col>
                          <v-col cols="12">
                            <v-divider />
                          </v-col>
                        </v-row>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-col class="text-center" cols="12" v-if="d.DFRequestDocItemStatusDD == 3">
                        <v-chip class="ma-2" color="red" text-color="white">
                          <i class="fas fa-exclamation-circle mr-2"></i> {{ $t("labels.NotSatisfied") }}
                        </v-chip>
                      </v-col>
                       <v-col class="text-center" cols="12" v-if="d.DFRequestDocItemStatusDD == 4">
                        <v-chip class="ma-2" color="black" text-color="white">
                          <i class="fas fa-check-circle mr-2"></i> {{ $t("labels.RDSubmitStatus") }}
                        </v-chip>
                      </v-col>

                      <div v-if="d.DFRequestDocItemStatusDD == 1 || d.DFRequestDocItemStatusDD == 3 || d.DFRequestDocItemStatusDD == 4">
                        <vue-dropzone
                          :id="'u1' + idx"
                          :options="getDZOpt(d.DFRequestDocItemID)"
                          :destroyDropzone="false"
                          :include-styling="true"
                          @vdropzone-success="onDropzoneSuccess"
                          @vdropzone-sending="onDropzoneSending"
                        ></vue-dropzone>
                      </div>
                      <!-- <div v-if="d.DFRequestDocItemStatusDD == 4">
                        <div class="text-center submitStatus">
                          <i class="fas fa-check-circle fa-3x"></i>
                          <div class="mt-2" style="color:black;" v-html="$t('labels.RDSubmitStatus')" />
                        </div>
                      </div> -->
                      <div v-if="d.DFRequestDocItemStatusDD == 2">
                        <div class="text-center satisfiedStatus">
                          <i class="fas fa-check-circle fa-3x"></i>
                          <div class="mt-2" style="color:black;" v-html="$t('labels.RDSatisfiedStatus')" />
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <!-- <div class="mt-5">  
                <div class="float-right">             
                  <v-btn v-show="showBackButton" @click="goBack()" color="primary" class="mx-auto mb-4 mr-2">
                    <i class="mr-2"></i> {{ $t("labels.Back") }}
                  </v-btn>
                  <v-btn :disabled="disableSubmitFlag" @click="submitDocs" color="primary" class="mx-auto mb-4">
                    <i class="fas fa-upload mr-2"></i> {{ $t("labels.Submit") }}
                  </v-btn>                   
                </div>              
               <br clear="all" />
              </div> -->
            
            </v-tab-item>
            <!-- <v-tab-item value="tab-2">
              <v-card flat>
                <v-card-text>
                 <p_note :requestDocID="app.RequestDocument.DFRequestDocID" :siteID="siteID" />
                </v-card-text>
              </v-card>
            </v-tab-item> -->
          </v-tabs-items>                 
        </v-card-text>
        <v-card-actions class="mb-5 mt-10">
            <v-spacer />
            <v-btn @click="next" color="primary">{{ $t("labels.Next") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
    <v-dialog ref="MergeDocumentsSelectModal" v-model="showRequestFlag" persistent   max-width="800px">  
      <v-card>
        <v-card-title>
          <span class="headline" v-text="$t('labels.RequestBankStatements')"></span>
        </v-card-title>   
         <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-select  v-model="RequestApplicant" :items="LstApplicants" item-text="Label" item-value="Value">
                  <template slot="label">
                    <span v-html="$t('labels.MTG_Applicants')" />
                  </template>
                </v-select> 
              </v-col>
            </v-row>
          </v-container>
         </v-card-text>
          <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="CloseRequestModal">{{$t('labels.Close')}}</v-btn>
          <v-btn :disabled="RequestApplicant == null" color="blue darken-1" text @click="RequestdialogSave(RequestApplicant)">{{$t('labels.SendRequest')}}</v-btn>
        </v-card-actions>
      </v-card>                   
    </v-dialog>
    <div class="loading" v-if="loadFlag">Loading&#8230;</div>   
  </div>
</template>

<script>
import drawer from "@/pages/app/agent/user/app/drawer";
import dataSvc from "@/services/dataService";
import localStorageSvc from "@/services/localStorage";
import model from "@/shared/dataModels/app";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import domainHelper from "@/services/domainHelper";
export default {
  components: {
    vueDropzone: vue2Dropzone, 
    drawer 
  },
  data() {
    return {
      frm: {
          LoginID: null,
          Tag: null,
          Institution: null,
          AccountId:null
            },
      LstApplicants:[],
      showRequestFlag: false, 
      RequestApplicant: null,
      tabModel: "tab-1",    
      loadFlag: false,    
      mortgageApplicationID: this.$route.params.appid,
      siteID: this.$route.params.siteid,
      userID: null,
      app: model.appModel(),
      lan: localStorageSvc.getLan()
    };
  },
  methods: { 
    RequestdialogSave(a){
      this.showRequestFlag = false;
      this.$confirm(
        this.$t("labels.Warning"),
        this.$t("messages.DisclaimerPoints"),
        () => {          
          let postData = {
            SiteID: this.siteID,
            MortgageApplicationID: this.mortgageApplicationID,
            ApplicantID: a
          };
          this.loadFlag = true;
          dataSvc
            .getHttp()
            .post("/api/MtgappRequestBankStatement", postData)
            .then(res => {
              this.loadFlag = false;
              if (res.data.ReturnStatus.ReturnCode == 200){
                // location.href = res.data.url;
                // window.open(res.data.url);
                window.open(res.data.url, "_blank");
              }else{
                 this.$alert(this.$t("Warning"), this.$t("errors.FeatureCreditInsufficientCredits"));
              }
            });
        },
        () => {}
      );
    },
     RequestStatement(){
      this.showRequestFlag = true;
      this.RequestApplicant = null;
    },
    CloseRequestModal(){
      this.showRequestFlag = false;
    },
    isNotRequested(a) {
      if (a.ReceivedFlag) return false;
      return !a.RequestedFlag;
    },
    isRequested(a) {
      if (a.ReceivedFlag) return false;
      return a.RequestedFlag;
    },
    isRecievedS3Key(a) {
      if (a.Responses.length <= 0) return false;
      for (let i = 0; i < a.Responses.length; i++) {
        if (a.Responses[i].S3Key) return true;
      }
      return false;
    },
    isRecieved(a) {
      return a.ReceivedFlag;
    },
     getDZOpt(DFRequestDocItemID) {
      return {
        url: domainHelper.getAPIHost() + "/WS/MTGAPPRDDZUpload/" + DFRequestDocItemID,

        parallelUploads: 3,
        // dictDefaultMessage: "<i class='fas fa-upload'></i><br />Drag & drop files here or select files to upload",
        dictDefaultMessage: this.setLabel(),
        previewTemplate: '<div><span data-dz-name></span> <i class="fas fa-spinner fa-spin"></i></div>',
        acceptedFiles: "image/*,.pdf,.doc,.docx,.zip,.xlsx,.xls",
        autoQueue: true,
        autoProcessQueue: true,
        thumbnailWidth: 0
      };
    },  
    setLabel(){
      if(this.lan == "en"){
        return "<i class='fas fa-upload'></i><br />Drag & drop files here or select files to upload"
      }else if(this.lan == "fr"){
        return "<i class='fas fa-upload'></i><br />glisser et déposez les fichiers ici ou sélectionnez les fichiers à télécharger"
      }
    },
    onDropzoneSending(file, xhr, formData) {
      formData.append("SiteID", this.siteID);
    },
    onDropzoneSuccess(file, res) {
      if (res == "OK") return;

      try {
        let rv = res;
        this.addFileTo(rv.DFRequestDocItemID, rv.DFRequestDocItemUploadID, rv.FileName, rv.strUploadDate);
      } catch (error) {
        console.error(error);
      }

      this.disableSubmitFlag = false;
      $(file.previewElement).remove();
    },
    addFileTo(dFRequestDocItemID, dFRequestDocItemUploadID, fileName, uploadDate) {
      for (let i = 0; i < this.app.RequestDocument.Items.length; i++) {
        let doc = this.app.RequestDocument.Items[i];
        if (doc.DFRequestDocItemID == dFRequestDocItemID) {
          doc.Uploads.push({
            FileName: fileName,
            DFRequestDocItemUploadID: dFRequestDocItemUploadID,
            strUploadDate: uploadDate,
            RemoveFlag: true
          });
        }
      }
    },
     removeUpload(dFRequestDocItemUploadID, dFRequestDocItemID) {
      this.$confirm(
        this.$t("labels.Warning"),
        this.$t("labels.ConfirmRemoveUpload"),
        () => {
          let postData = {
            SiteID: this.siteID,
            DFRequestDocItemUploadID: dFRequestDocItemUploadID,
            RequestDocID: this.app.RequestDocument.DFRequestDocID
          };
          this.loadFlag = true;
          dataSvc
            .getHttp()
            .post("/api/RDRemoveUploadV2", postData)
            .then(res => {
              this.loadFlag = false;
              for (let i = 0; i < this.app.RequestDocument.Items.length; i++) {
                if (this.app.RequestDocument.Items[i].DFRequestDocItemID == dFRequestDocItemID) {
                  let uploads = this.app.RequestDocument.Items[i].Uploads;

                  this.app.RequestDocument.Items[i].Uploads = uploads.filter(function(el) {
                    return el.DFRequestDocItemUploadID != dFRequestDocItemUploadID;
                  });

                  break;
                }
              }
            });
        },
        () => {}
      );
    },
    loadPage() {
      let lang = localStorageSvc.getLan();
      if(lang == 'fr' || lang == "FR")
        lang = 2;
      else
        lang = 1;
      this.loadFlag = true;
      let postData = {
        SiteID: this.siteID,
        UserID: this.userID,
        MortgageApplicationID: this.mortgageApplicationID,
        LanguageID: localStorageSvc.getLanID()
      };
      dataSvc
        .getHttp()
        .post("/api/MTGAPPLoad", postData)
        .then(res => {
          this.loadFlag = false;
          var lan = localStorageSvc.getLanID();
          if (res.data.ReturnStatus.ReturnCode == 200) {
            this.app = res.data;   
            for (let i = 0; i < res.data.BankStatementsApplicants.length; i++)
                  this.LstApplicants.push({
                    Label: res.data.BankStatementsApplicants[i].ApplicantName,
                    Value: res.data.BankStatementsApplicants[i].ApplicantID,
                  });                  
          }
          this.app.UserID = this.userID;
          this.app.SiteID = this.siteID;
        });
    },
    back() {
      this.$router.push("/" + this.siteID + "/user/" + this.mortgageApplicationID + "/applicant/" + this.applicantID + "/address");
    },
    
    next() {
      let postData = {
        DFRequestDocID: this.app.RequestDocument.DFRequestDocID,
        SiteID: this.siteID,
        UserID: this.userID,
        MortgageApplicationID: this.mortgageApplicationID,
        reqRequestDocument: this.app.reqRequestDocument
      };

      this.loadFlag = true;
      dataSvc
        .getHttp()
        .post("/api/MTGAPPDoneRequestDocument", postData)
        .then(res => {         
          this.loadFlag = false;
          if(res.data.ReturnStatus.ReturnCode == 200){
              if(this.app.showBankStatement == true){
              this.$router.push("/" + this.siteID + "/user/" + this.mortgageApplicationID + "/bankStatement");
            }else{
            this.$router.push("/" + this.siteID + "/user/" + this.mortgageApplicationID + "/summary");
            }
          }else{
            this.$alert(this.$t("Warning"), this.$t("errors.RequestDocumentReqUploads"));
          }
          
          //to summary
        });
    },
    
    
  },
  created() {
    this.userID = localStorageSvc.getUser();
    if (this.userID != "") {
       this.frm.LoginID = this.$route.query.loginId;
        this.frm.strTag = this.$route.query.tag;
        this.frm.Institution = this.$route.query.institution;
        this.frm.AccountId = this.$route.query.accountId;        
        if(this.frm.LoginID == null){
          this.loadPage();
        }else{
          this.loadFlag = true;
          dataSvc.getHttp().post('/v1/flinks/SaveFlinksResponse', this.frm).then(res => {
            // this.loadPage();
            this.$router.push("/" + this.siteID + "/user/" + this.mortgageApplicationID + "/request");          
        });
        }
      
    } else {
      this.$router.push("/" + this.siteID);
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.applicantID = to.params.applicantid;
    this.loadPage();
    next();
  },
  watch: {
  }
};
</script>

<style></style>
